/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 416);
/******/ })
/************************************************************************/
/******/ ({

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Returns = /*#__PURE__*/function () {
  function Returns(element) {
    _classCallCheck(this, Returns);

    this.element = element;
    this.init();
  }

  _createClass(Returns, [{
    key: "getElement",
    value: function getElement() {
      return this.element;
    }
  }, {
    key: "getButton",
    value: function getButton() {
      var element = this.getElement();
      return element.querySelector('.js-startReturns');
    }
  }, {
    key: "getForm",
    value: function getForm() {
      var element = this.getElement();
      return element.querySelector('.js-form');
    }
  }, {
    key: "getDetails",
    value: function getDetails() {
      var element = this.getElement();
      return element.querySelector('.js-details');
    }
  }, {
    key: "getBack",
    value: function getBack() {
      var element = this.getElement();
      return element.querySelector('.js-goBack');
    }
  }, {
    key: "getCheckbox",
    value: function getCheckbox() {
      var element = this.getElement();
      return element.querySelector('.js-checkbox');
    }
  }, {
    key: "getBlocks",
    value: function getBlocks() {
      var element = this.getElement();
      return element.querySelectorAll('.js-block');
    }
  }, {
    key: "showForm",
    value: function showForm() {
      var formEl = this.getForm();
      formEl.classList.add('active');
    }
  }, {
    key: "showDetails",
    value: function showDetails() {
      var details = this.getDetails();
      details.classList.add('active');
    }
  }, {
    key: "hideForm",
    value: function hideForm() {
      var formEl = this.getForm();
      formEl.classList.remove('active');
    }
  }, {
    key: "hideDetails",
    value: function hideDetails() {
      var details = this.getDetails();
      details.classList.remove('active');
    }
  }, {
    key: "toggleBlocks",
    value: function toggleBlocks() {
      var blockEl = this.getBlocks();

      var _iterator = _createForOfIteratorHelper(blockEl),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var block = _step.value;
          block.classList.contains('active') ? block.classList.remove('active') : block.classList.add('active');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setBack",
    value: function setBack() {
      var _this = this;

      var backEl = this.getBack();
      backEl.addEventListener('click', function () {
        _this.hideForm();

        _this.showDetails();
      });
    }
  }, {
    key: "setButton",
    value: function setButton() {
      var _this2 = this;

      var startReturnsButton = this.getButton();
      startReturnsButton.addEventListener('click', function () {
        _this2.showForm();

        _this2.hideDetails();
      });
    }
  }, {
    key: "setCheckbox",
    value: function setCheckbox() {
      var _this3 = this;

      var checkboxEl = this.getCheckbox();
      checkboxEl.addEventListener('click', function () {
        _this3.toggleBlocks();
      });
    }
  }, {
    key: "setEventHandlers",
    value: function setEventHandlers() {
      this.setButton();
      this.setBack();
      this.setCheckbox();
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventHandlers();
    }
  }]);

  return Returns;
}();

var ReturnsInit = {
  init: function init() {
    var $el = document.querySelector(".js-returns");

    if ($el) {
      new Returns($el);
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (ReturnsInit);
ReturnsInit.init();

/***/ })

/******/ });
//# sourceMappingURL=component.returnsPage.js.mapv